module.exports = __webpack_public_path__ + "static/img/twin-wateway-2.c5d2b064.png";